import { Link } from "react-router-dom";
import { NEEDS_ATTENTION_SEVERITY } from "../../../store/admin/investorPortal/constants";
import { buildGroupedAttention } from "../../../store/admin/investorOperations/needsAttention";

export default function AdminNeedsAttentionCard({ item }) {
  const palette = NEEDS_ATTENTION_SEVERITY[item.severity] || NEEDS_ATTENTION_SEVERITY.neutral;

  const inner = (
    <div
      className="admin-needs-attention-card h-100"
      style={{ background: palette.bg, borderColor: palette.border }}
    >
      <div className="d-flex justify-content-between align-items-start gap-2 mb-2">
        <span className="admin-needs-attention-count" style={{ color: palette.text }}>
          {item.count}
        </span>
        {item.badge ? (
          <span className="admin-needs-attention-badge" style={{ color: palette.text, borderColor: palette.border }}>
            {item.badge}
          </span>
        ) : null}
      </div>
      <h6 className="fw-semibold mb-1" style={{ color: "#383838", fontSize: 14 }}>
        {item.title}
      </h6>
      <p className="text-muted small mb-2">{item.description}</p>
      {item.cta ? (
        <span className="small fw-semibold" style={{ color: palette.text }}>
          {item.cta} →
        </span>
      ) : null}
    </div>
  );

  if (item.path) {
    return (
      <Link to={item.path} className="text-decoration-none d-block h-100">
        {inner}
      </Link>
    );
  }

  return inner;
}

export function AdminNeedsAttentionGrid({ items = [] }) {
  if (!items.length) {
    return (
      <p className="text-muted small mb-0 py-2">
        Nothing urgent right now. Review funding progress and recent activity below.
      </p>
    );
  }

  return (
    <div className="row g-3">
      {items.map((item) => (
        <div key={item.id} className="col-12 col-md-6 col-xl-4">
          <AdminNeedsAttentionCard item={item} />
        </div>
      ))}
    </div>
  );
}

export function AdminNeedsAttentionGrouped({ items = [] }) {
  const groups = buildGroupedAttention(items);

  if (!groups.length) {
    return (
      <p className="text-muted small mb-0 py-2">
        Nothing urgent right now. Review funding progress and recent activity below.
      </p>
    );
  }

  return (
    <div className="d-flex flex-column gap-4">
      {groups.map(({ group, items: groupItems }) => (
        <div key={group}>
          <h6 className="text-muted small text-uppercase fw-semibold mb-2">{group}</h6>
          <div className="row g-3">
            {groupItems.map((item) => (
              <div key={item.id} className="col-12 col-md-6 col-xl-4">
                <AdminNeedsAttentionCard item={item} />
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
